import { dDom } from '../../../core/js/utils/renderUtils';
import template from 'category-h1-inner.j2';
import { generate } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';

/**
 * Category H1 Component Init
 * @param store
 * @param overrides
 * @returns {*}
 */
export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.js-category-h1',
        watch: 'category.catalogRequestUrl',
        name: 'categoryH1',
        template: template,
        renderType: dDom
    };
    return generate(config, store, overrides, getDefaultOptions(store));
}
